/**
 * @module qbLinkage/detectChanges/detectCompareTime
 * @description 对比时间筛选检测
 */

export interface ICompareTimeState {
  enabled: boolean;
  dateFieldKey?: string;
}

export function detectCompareTime(
  filters: unknown[] | undefined,
): ICompareTimeState {
  if (!filters?.length) {
    return { enabled: false };
  }
  for (const f of filters) {
    const row = f as Record<string, unknown>;
    const compareTimes = row.compareTimes as unknown[] | undefined;
    if (Array.isArray(compareTimes) && compareTimes.length > 0) {
      const key = String(row.column_name ?? row.column ?? '');
      return { enabled: true, dateFieldKey: key };
    }
  }
  return { enabled: false };
}
